import { ThemeType, isThemeType } from '@riotgames/accounts-react-components/lib/Theme';
import Flow from '../FlowManager/flow';

// Themes from https://gh.riotgames.com/riotsignon/rso-configuration/blob/master/configs/globalriot.pdx2.prod.accounts.rso-provider-web.properties#L175
export const CONFIG_THEME = {
  map: {
    'blue-tape-web-prod': 'lor',
    'rso-web-client-prod': 'lol',
    'play-valorant-web-prod': 'valorant'
  },
  enabled: ['riot', 'lol', 'valorant', 'lor']
};

export function getInitialTheme(parameters, config) {
  let theme = ThemeType.riot;
  const { client_id: client, riot_theme: override } = parameters;
  const { map, enabled } = config || {};

  if (override && enabled && isThemeType(override) && enabled.includes(override)) {
    theme = override;
  } else if (client && map) {
    const pureClientId = client
      .split('-')
      .slice(0, -1)
      .join('-');
    const mappedClientId = Object.keys(map).filter((m) => m.startsWith(pureClientId))[0];
    const mapped = map[client] || map[mappedClientId];

    if (isThemeType(mapped)) {
      theme = mapped;
    }
  }

  return theme;
}

export function getInitialState(isAdult = true, token = '') {
  const signupType = token ? 'PROMOTION' : 'DEFAULT';
  const pageTitle = token ? '라이엇 계정으로 업그레이드' : '라이엇 계정 생성';
  const sessionToken = token;
  const flows = isAdult ? Flow[`${signupType}`].NORMAL : Flow[`${signupType}`].MINOR;

  return {
    flows,
    signupType,
    sessionToken,
    pageTitle,
    step: {
      component: flows[0].curr,
      page: 0,
      pageCount: flows.filter((flow) => flow.nextIncreaseCount).length + 1
    }
  };
}
